export const DYNAMIC_TABLE_DATA_ELEMENT = '[data-element="dynamic-table"]';

// CLASSES
export const COMPONENT_CLASS = 'at-dynamic-table';
export const SHADOW_CLASS = `${COMPONENT_CLASS}__shadow`;
export const SHADOW_EARLIER_CLASS = `${SHADOW_CLASS}-earlier`;
export const SHADOW_LATER_CLASS = `${SHADOW_CLASS}-later`;

// SELECTORS
export const COMPONENT_SELECTOR = `.${COMPONENT_CLASS}`;
export const NAVIGATION_SELECTOR = `${COMPONENT_SELECTOR}__navigation`;
export const NAVIGATION_PREV_BUTTON_SELECTOR = `${COMPONENT_SELECTOR}__navigation-prev`;
export const NAVIGATION_NEXT_BUTTON_SELECTOR = `${COMPONENT_SELECTOR}__navigation-next`;
export const HEADER_TITLE_SELECTOR = `${COMPONENT_SELECTOR}__header-title`;
export const CONTENT_SELECTOR = `${COMPONENT_SELECTOR}__content`;
export const ROW_SELECTOR = `${COMPONENT_SELECTOR}__row`;
export const SCROLLABLE_HEADER_SELECTOR = `${COMPONENT_SELECTOR}__scrollable-header`;
export const SCROLLABLE_CONTENT_SELECTOR = `${COMPONENT_SELECTOR}__scrollable-content`;

export const DIRECTION = {
  PREV: 0,
  NEXT: 1,
};

export const SCREENSIZE_SM = 640;
export const SWIPE_THRESHOLD = 50;